import React from "react";
import { AlertCircle, Info } from "lucide-react";

export const ColumnMappingInfo = ({ mapping, unmappedColumns }) => {
  if (!mapping || Object.keys(mapping).length === 0) return null;

  const mappedEntries = Object.entries(mapping).filter(
    ([original, canonical]) => original !== canonical
  );

  const exactMatches = Object.entries(mapping).filter(
    ([original, canonical]) => original === canonical
  );

  if (
    mappedEntries.length === 0 &&
    unmappedColumns.length === 0 &&
    exactMatches.length === 0
  ) {
    return null;
  }

  return (
    <div className="space-y-3">
      {mappedEntries.length > 0 && (
        <div className="p-4 bg-blue-50 rounded-md border border-blue-300">
          <div className="flex items-center mb-3">
            <Info className="w-5 h-5 text-blue-600 mr-2" />
            <p className="font-semibold text-blue-800">
              Automatic Column Mapping Applied ({mappedEntries.length})
            </p>
          </div>
          <p className="text-sm text-blue-700 mb-3">
            The following column names were automatically recognized and mapped
            to the standard format:
          </p>
          <div className="max-h-48 overflow-y-auto space-y-2 pr-2">
            {mappedEntries.map(([original, canonical]) => (
              <div
                key={original}
                className="flex items-center gap-2 text-xs bg-blue-100 p-2.5 rounded border border-blue-200"
              >
                <span className="font-mono text-blue-900 bg-white px-2 py-1 rounded border border-blue-300">
                  {original}
                </span>
                <span className="text-blue-600 font-bold">→</span>
                <span className="font-mono font-semibold text-blue-900 bg-blue-200 px-2 py-1 rounded border border-blue-400">
                  {canonical}
                </span>
              </div>
            ))}
          </div>
          <p className="text-xs text-blue-600 mt-3 italic">
            💡 Your data will be processed using the standardized column names
            shown on the right.
          </p>
        </div>
      )}
      {unmappedColumns && unmappedColumns.length > 0 && (
        <div className="p-4 bg-yellow-50 rounded-md border border-yellow-300">
          <div className="flex items-center mb-3">
            <AlertCircle className="w-5 h-5 text-yellow-600 mr-2" />
            <p className="font-semibold text-yellow-800">
              Unrecognized Columns ({unmappedColumns.length})
            </p>
          </div>
          <p className="text-sm text-yellow-700 mb-2">
            These columns were not recognized and will be ignored during upload:
          </p>
          <div className="flex flex-wrap gap-2">
            {unmappedColumns.map((col) => (
              <span
                key={col}
                className="inline-block px-3 py-1 text-xs font-mono bg-yellow-100 text-yellow-800 rounded border border-yellow-300"
              >
                {col}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
